package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_01_27_Day_1
import com.veldekar.components.logs.Log_2023_01_27_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-01-27")
@Composable
public fun Log_2023_01_27(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Gnolls and Cultists",
        ogTitle = "Gnolls and Cultists",
        date = LocalDate(2_023, 1, 27),
        ogDescription = "After slaying a group of Gnolls, the heroes encounter and interrogate cultists worshipping the demon Sklyx.",
        ogImage = "ai/2023-01-27.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-11", dateString = "Newgrowth 11")
        Log_2023_01_27_Day_1()
        SessionDayHeader(dayId = "newgrowth-12", dateString = "Newgrowth 12")
        Log_2023_01_27_Day_2()
    }
}
